
<template>
    <div v-if="showModel" class="edit-model">
        <div class="img-div">
            <div>{{title}}</div>
            <div class="close-img" @click="cancel">
                <i class="iconfont">&#xe641;</i>
            </div>
        </div>
        <Form ref="formData" :model="formData" :rules="ruleCustom" :label-width="80">
            <FormItem label="登录账号" prop="name">
                <Input type="text" v-model="formData.name"></Input>
            </FormItem>
            <FormItem label="登录密码" prop="password">
                <Input type="password" v-model="formData.password"></Input>
            </FormItem>
            <FormItem label="用户昵称" prop="nickname">
                <Input type="text" v-model="formData.nickname"></Input>
            </FormItem>
            <FormItem label="用户头像" prop="avatar">
                <ImgUpload
                    ref="upLogoImg"
                    :action="uploadUsersAvatar"
                    :hasUpload="hasUpload"
                    :num="1"
                    @setThumbUrl="setThumbUrlthumb"
                ></ImgUpload>
            </FormItem>
            <FormItem label="账户状态" prop="status" class="ivu-form-item-required">
                <RadioGroup v-model="formData.status">
                    <Radio label="1">
                        <span>正常</span>
                    </Radio>
                    <Radio label="2">
                        <span>禁用</span>
                    </Radio>
                    <Radio label="3">
                        <span>禁删</span>
                    </Radio>
                </RadioGroup>
            </FormItem>
            <FormItem label="系统角色" prop="role_id" class="ivu-form-item-required">
                <Select v-model="formData.role_id" clearable label-in-value>
                    <Option v-for="(item,index) in list" :value="item.id" :key="index">{{item.name}}</Option>
                </Select>
            </FormItem>
            <FormItem label="邮箱" prop="email">
                <Input type="text" v-model="formData.email"></Input>
            </FormItem>
            <FormItem label="手机号" prop="mobile">
                <Input type="text" v-model="formData.mobile"></Input>
            </FormItem>
            <FormItem label="负责部门" prop="lead_section_ids" >
                <SearchSelect :isMultiple='1' ref="leadSectionIds" :url="searchSectionUrl" labelName='section_name' valName='id' keyword="keyword" @setSelected="setSelectVal($event,'lead_section_ids')"></SearchSelect>
            </FormItem>
            <FormItem>
                <Button :disabled="disabled" type="primary" @click="subData('formData')">确定</Button>
            </FormItem>
        </Form>
    </div>
</template>
<script>
/**
 * 弹框
 * @param showModel boolean 对话框开关 true false
 * @param fn function 回调函数
 * @param type Number 类型 1添加 2编辑
 * @param editFormData Object 编辑时的数据
 */
import common from "@/common/common";
import ImgUpload from "@/views/common/upload";
import SearchSelect from '@/views/common/selectList';

export default {
  props: {
    showModel: Boolean,
    fn: Function,
    type: Number,
    editFormData: Object
  },
  name: "Model1",
  components: {
    ImgUpload,
      SearchSelect
  },
  data() {
    var Phone = function(rule, value, callback){
        if(!value.match(/^1[0-9]{10}$/)){
            return callback(new Error("请输入正确的手机格式"));
        }else{
            callback();
        }
    };
    return {
      title: "添加",
      disabled: false,
      searchSectionUrl: this.config.urlArray.getAllSection,
      uploadUsersAvatar: this.config.urlArray.usersAvatar, //上传图片接口
      hasUpload: [], //已上传图片
      list: [],
      userList: [],
      defaultData: {
          id:"",
        name: "",
        password: "",
        nickname: "",
        status: "1",
        role_id: "",
        avatar: "",
        email: "",
        mobile: "",
          lead_section_ids:''
      },
      formData: {},
      ruleCustom: {
        //验证
        name: [
          { required: true, message: "登录账号必须填写", trigger: "blur" },
        ],
        nickname: [
          { required: true, message: "用户昵称必须填写", trigger: "blur" },
        ],
        // avatar: [
        //   { required: true, message: "用户头像必须填写", trigger: "blur" },
        // ],
        role_id: [
           { required: true, message: "请选择系统角色", trigger: "blur" ,type:"number"},
         ],
        email: [
          { required: true, message: "邮箱必须填写", trigger: "blur" },
        ],
        mobile: [{required: true,validator: Phone, trigger: 'blur'}],
      }
    };
  },
  watch: {
    showModel(val) {
      if (val) {
        this.getRoleData();
        if (this.type && this.type == 2) {
          this.title = "编辑";
          this.editForm();
        }
        if (this.type && this.type == 1) {
          this.title = "添加";
          this.formData = this.defaultData;
        }
      }
    }
  },
  methods: {
    editForm() {
      for (let key in this.defaultData) {
        this.defaultData[key] =
          this.editFormData[key] instanceof Array ||
          this.editFormData[key] instanceof Object
            ? this.editFormData[key]
            : String(this.editFormData[key]);
        if (!this.editFormData[key]) {
          this.defaultData[key] = "";
        }
      }

      this.formData = this.defaultData;
      this.formData.lead_section_ids = this.formData.lead_section_ids.split(',').map(Number)
      this.formData.role_id = Number(this.formData.role_id)
      this.$nextTick(() => {
          let hasUpload = [
            {
            status: "finished",
            response: { data:{path:this.formData.avatar}}
            }
        ];
        this.$refs.upLogoImg.setHasUpload(hasUpload); //为上传组件付默认值
          setTimeout(() => {
              console.log(this.formData.lead_section_ids)
              this.$refs.leadSectionIds.setDefVal(this.formData.lead_section_ids);
          }, 500);
      });
    },
    setThumbUrlthumb(url) {
      this.formData.avatar = url;
    },
    getRoleData() {
      //获取数据
      this.axios
        .get(this.config.urlArray.usersRole, {})
        .then(result => {
          common.ajaxMsg(result.data);
          this.list = result.data.data;
        })
        .catch(err => {
          common.msg("error", "获取失败", () => {});
        });
    },
    subData(name) {
      //提交表单
      this.$refs[name].validate(valid => {
        if (valid) {
          this.disabled = true;
          this.axios
            .post(this.config.urlArray.usersStore, this.formData)
            .then(result => {
              common.ajaxMsg(
                result.data,
                true,
                () => {
                  //提交表单后的回调处理
                  this.resetForm(); //重置表单
                  this.fn();
                },
                () => {
                  this.disabled = false;
                }
              );
            })
            .catch(err => {
              common.msg("error", "提交失败", () => {
                this.disabled = false;
              });
            });
        }
      });
    },
      setSelectVal(data,key){
          this.formData[key] = data.join(',')
      },
    cancel() {
      //对话框关闭
      this.$emit("update:showModel", false);
      this.fn();
    },
    setThumbUrl(url) {
      //获取图片上传后的路径
      this.formData.thumb = url;
    },
    resetForm() {
      //重置表单
      this.$refs.leadSectionIds.clearVal();
      this.defaultData = {
        id: "",
        name: "",
        password: "",
        nickname: "",
        status: "1",
        role_id: "",
        avatar: "",
        email: "",
        mobile: "",
        lead_section_ids:''
      };
      this.formData.id = '';
      this.$refs.formData.resetFields(); //重置表单
      this.disabled = false; //恢复提交按钮为激活状态
    }
  }
};
</script>
<style lang='scss' scoped>
.edit-model {
  position: relative;
  .img-div {
    width: 100%;
    position: relative;
    display: flex;
    align-items: center;
    justify-content: space-between;
    height: 45px;
    div {
      font-weight: bold;
      font-size: 15px;
    }
  }
  .close-img {
    border: 1px solid #fd6363;
    display: inline-block;
    line-height: 100%;
    border-radius: 100%;
    padding: 5px;
    color: #f00;
    right: 10px;
    top: 10px;
    z-index: 3;
    cursor: pointer;
  }
  .close-img:hover {
    transform: scale(1.1);
    transition: all 0.3s;
  }
}
.form-div {
  display: flex;
  .right-ss {
    padding-left: 20px;
    box-sizing: border-box;
    flex: 1;
    word-break: break-all;
    min-width: 300px;
    .list {
      max-height: 500px;
      overflow-y: auto;
      .item {
        margin: 10px 0px;
        border-bottom: 1px dashed #ccc;
        p {
          display: flex;
          span:nth-of-type(1) {
            font-weight: bold;
            margin-right: 4px;
            width: 60px;
            display: inline-block;
          }
          span:nth-of-type(2) {
            flex: 1;
            font-size: 12px;
          }
        }
      }
      .activeP {
        background: linear-gradient(to bottom, #25cbae 0%, #cdfff5 100%);
      }
    }
  }
}
</style>
